import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const Main = styled.main.attrs({
  className: 'mx-auto max-width-6 pb-9 px-5 mt-5 wide-container-padding main-font-down-1 md-pl-9 mt-sm-7',
})`
  & p {
    font-size: 1.6rem !important;
  }
`;

export const TopLevelOrderedList = styled(Typography).attrs({ as: 'ol' })`
  list-style: none;

  & > li > h2 {
    margin-left: ${({ theme }) => theme.space.s4};
  }

  ${({ theme }) => theme.mediaQueries.mediumDown} {
    & > li > h2 {
      margin-left: 0;
    }
  }
`;

export const TabbedList = styled(Typography).attrs({ as: 'ul' })`
  padding-left: ${props => props.theme.space.s5};
  list-style: inside;

  & > li {
    margin-bottom: ${({ theme }) => theme.space.s4};
  }
`;

export const NestedList = styled(Typography).attrs({ as: 'ul' })`
  padding-left: ${props => props.theme.space.s7};
  list-style: circle;

  & > li {
    margin-bottom: ${({ theme }) => theme.space.s2};
    margin-top: ${({ theme }) => theme.space.s2};
  }
`;

export const DoubleNestedList = styled(Typography).attrs({ as: 'ul' })`
  padding-left: ${props => props.theme.space.s7};
  list-style: square;

  & > li {
    margin-bottom: ${({ theme }) => theme.space.s2};
    margin-top: ${({ theme }) => theme.space.s2};
  }
`;

export const Table = styled(Typography).attrs({ as: 'table' })`
  margin: ${props => props.theme.space.s4} ${props => props.theme.space.s7};
  border: 1px solid ${props => props.theme.colors.capsuleBlue60};
  border-collapse: collapse;
`;

export const TableHeader = styled(Typography).attrs({ as: 'th' })`
  padding: ${props => props.theme.space.s2};
  font-weight: ${props => props.theme.fontWeights.bold};
  border: 1px solid ${props => props.theme.colors.capsuleBlue60};
  border-collapse: collapse;
`;

export const TableCell = styled(Typography).attrs({ as: 'td' })`
  padding: ${props => props.theme.space.s2};
  border: 1px solid ${props => props.theme.colors.capsuleBlue60};
  border-collapse: collapse;
`;
